module.exports = __webpack_public_path__ + "img/dollar.a63946de.png";